import { getAxiosInstance } from "@/axiosClient";

class MetricaService {
  get axios() {
    return getAxiosInstance();
  }
  async fetchToolUsage() {
    const response = await this.axios.get("/api/metrica/tool-usage");
    return response;
  }
}

export default new MetricaService();
